import { render, staticRenderFns } from "./InsuredList.vue?vue&type=template&id=5e0cfa9b&"
import script from "./InsuredList.vue?vue&type=script&lang=js&"
export * from "./InsuredList.vue?vue&type=script&lang=js&"
import style0 from "./InsuredList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InsuredList.vue"
export default component.exports